import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RetornoEmailComponent } from './retorno-email.component';

@NgModule({
  declarations: [
    RetornoEmailComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    RetornoEmailComponent
  ]
})

export class RetornoEmailModule { }
